module.exports = __webpack_public_path__ + "img/WhatsApp Image 2020-07-01 at 11.26.13 AM.08354f5c.jpeg";